import { Input } from '@sketch-note/design-system/src/components/text-input';
import { Button } from '@sketchnote/shared-components';
import * as React from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { useLoaderStore } from 'src/components/loaders';
import { useLayout } from 'src/shared/hooks/use-layout';

import { useSettings } from '../../store';

export const ChangePassword = ({ onClose }: { onClose: () => void }): JSX.Element => {
  interface Values {
    oldPassword: string;
    newPassword: string;
    reEnterPassword: string;
  }
  const { onLogout } = useLayout();
  const { register, handleSubmit, control, setError, getValues } = useForm<Values>();
  const { errors } = useFormState({ control });
  const [callbacks] = useSettings();
  const { setIsLoading, isLoading } = useLoaderStore();
  const handleLogOut = () => {
    onLogout();
  };

  const onSubmit = async (values: Values) => {
    setIsLoading(true);
    const results = await callbacks?.onChangePassword?.({
      newPassword: values.newPassword,
    });
    if (results?.isSuccess) {
      setIsLoading(false);
      onClose();
      handleLogOut();
    }

    return;
  };

  return (
    <div>
      <div className="text-sm text-gray-600">
        We will log you out after you make the change for security reasons. Log back in with your
        new password
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* <Input
          labelClassName="mt-32"
          wrapperClassName="pt-7 pb-7 px-12 "
          label="Old Password"
          inputProps={{
            name: 'oldPassword',
            ref: register({
              required: 'Required'
            })
          }}
          type="password"
          placeholder="Old password"
          status={errors.oldPassword ? 'danger' : undefined}
          caption={errors?.oldPassword?.message}
        /> */}
        <Input
          labelClassName="mt-24"
          wrapperClassName="pt-7 pb-7 px-12 "
          label="New Password"
          type="password"
          inputProps={{
            ...register('newPassword', {
              required: true,
            }),
          }}
          placeholder="New password"
          status={errors.newPassword ? 'danger' : undefined}
          caption={errors?.newPassword?.message}
        />
        <Input
          labelClassName="mt-24"
          type="password"
          label="Re-enter Password"
          inputProps={{
            ...register('reEnterPassword', {
              required: true,
              validate: () => getValues('newPassword') === getValues('reEnterPassword'),
            }),
          }}
          wrapperClassName="pt-7 pb-7 px-12"
          placeholder="Re-enter your new password"
          status={errors.reEnterPassword ? 'danger' : undefined}
          caption={
            errors?.reEnterPassword?.message || errors.reEnterPassword?.type === 'validate'
              ? "Password doesn't match"
              : ''
          }
        />
        <div className="flex h-48 justify-end mt-32">
          <Button status="secondary" className="mr-12 min-w-107 justify-center" onClick={onClose}>
            Cancel
          </Button>
          <Button status="primary" size="lg" className="justify-center" type="submit">
            Change password
          </Button>
        </div>
      </form>
    </div>
  );
};
